import { lineTotal, unitCodeFor } from '../utils/salesPipeline';

// Line items keep their snake_case keys (product_id, unit_price, …) so the shape
// travels unchanged between the form, the API and the offer/invoice line items.

export const mapAcquisitionDto = (dto) => ({
    id: dto.id,
    companyName: dto.company_name,
    contactPerson: dto.contact_person,
    contactEmail: dto.contact_email,
    contactPhone: dto.contact_phone,
    projectTitle: dto.project_title,
    projectDescription: dto.project_description,
    classification: dto.classification,
    expectedBudget: dto.expected_budget,
    status: dto.status,
    priority: dto.priority || 'Medium',
    estimatedCloseDate: dto.estimated_close_date,
    offerFilePath: dto.offer_file_path,
    offerAmount: dto.offer_amount,
    offerDate: dto.offer_date,
    notes: dto.notes,
    dealType: dto.deal_type || 'project',
    lineItems: dto.line_items || [],
    leadSource: dto.lead_source,
    contactAttempts: dto.contact_attempts ?? 0,
    lastContactDate: dto.last_contact_date,
    nextFollowUpDate: dto.next_follow_up_date,
    winProbability: dto.win_probability,
    lostReason: dto.lost_reason,
    ownerUserId: dto.owner_user_id,
    ownerName: dto.owner_name,
    stageChangedAt: dto.stage_changed_at,
    organisationId: dto.organisation_id,
    companyId: dto.company_id,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
});

/** Drop empty positions and let the numbers be numbers before sending them off. */
export const cleanLineItems = (items = []) =>
    items
        .filter(it => (it.description || '').trim() || parseFloat(it.unit_price) > 0)
        .map(it => ({
            product_id: it.product_id || null,
            description: (it.description || '').trim(),
            sub_description: (it.sub_description || '').trim() || null,
            quantity: parseFloat(it.quantity) || 0,
            unit: it.unit || 'Stk',
            unit_code: it.unit_code || unitCodeFor(it.unit),
            unit_price: parseFloat(it.unit_price) || 0,
            discount_percent: parseFloat(it.discount_percent) || 0,
            total: lineTotal(it),
        }));

const orNull = (value) => (value === '' || value === undefined ? null : value);

/** Frontend form shape → API payload (snake_case). */
export const toAcquisitionPayload = (form) => {
    const lineItems = cleanLineItems(form.lineItems);
    return {
        company_name: form.companyName,
        contact_person: form.contactPerson,
        contact_email: form.contactEmail || '',
        contact_phone: form.contactPhone || '',
        project_title: form.projectTitle,
        project_description: form.projectDescription || '',
        classification: orNull(form.classification),
        // With positions present the backend recomputes the value from them.
        expected_budget: form.expectedBudget === '' || form.expectedBudget === null
            ? null
            : Number(form.expectedBudget),
        status: form.status || 'Lead',
        priority: form.priority || 'Medium',
        estimated_close_date: orNull(form.estimatedCloseDate),
        offer_amount: form.offerAmount === '' || form.offerAmount === null ? null : Number(form.offerAmount),
        offer_date: orNull(form.offerDate),
        notes: orNull(form.notes),
        deal_type: form.dealType || 'project',
        line_items: lineItems,
        lead_source: orNull(form.leadSource),
        last_contact_date: orNull(form.lastContactDate),
        next_follow_up_date: orNull(form.nextFollowUpDate),
        win_probability: form.winProbability === '' || form.winProbability === null || form.winProbability === undefined
            ? null
            : Number(form.winProbability),
        lost_reason: orNull(form.lostReason),
        owner_user_id: orNull(form.ownerUserId),
        company_id: orNull(form.companyId),
    };
};
